/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminListCustomerMoneyPoolsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminListCustomerMoneyPoolsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminListCustomerMoneyPools = (request:AdminListCustomerMoneyPoolsRequest, options?: CashRequestOptions) => post<AdminListCustomerMoneyPoolsRequest, AdminListCustomerMoneyPoolsResponse>("/2.0/cash/admin-list-customer-money-pools", request, {...options, rejectOnError: true })